@if (viewModel$ | async; as viewModel) {
    <div class="grid grid-wrapper popular-multi-bet-widget-container">
        <ng-template #badgeContainer />
        @if (viewModel.showHeader) {
            <ms-popular-bets-module-header [title]="viewModel.title" [titleIconClass]="viewModel.titleIconClass" />
        }
        <ms-scroll-adapter
            size="medium"
            [scrollSpeed]="scrollSpeed"
            [scrollItems]="viewModel.payload"
            (select)="onPodScroll()"
            (mobileSwipe)="onPodSwipe()">
            <ul class="popular-multi-bets-scroll" [style.min-height.px]="viewModel.minHeight" [style.min-width.px]="viewModel.minWidth">
                <li class="popular-bets-pod" *rxFor="let pod of viewModel.payload; index as i; trackBy: trackByPod; renderCallback: itemsRendered">
                    @if (pod.backgroundImage && pod.backgroundImage.src) {
                        <img
                            priority
                            class="popular-bets-pod-bg-image"
                            [ngSrc]="pod.backgroundImage.src"
                            [height]="pod.backgroundImage.height"
                            [width]="pod.backgroundImage.width"
                            [alt]="pod.backgroundImage.alt ?? 'pod-bg-image'" />
                    }
                    @if (shouldShowBetBuilderPlusPod(pod)) {
                        <ms-popular-bets-bet-builder-plus-pod
                            msPopularBetsPodBackground
                            [pod]="pod"
                            [isEpcotEnabled]="isEpcotEnabled"
                            [visiblePodLegs]="visiblePodLegs" />
                    } @else if (shouldShowBetBuilderPod(pod)) {
                        <ms-popular-bets-bet-builder-pod
                            msPopularBetsPodBackground
                            [pod]="pod"
                            [isEpcotEnabled]="isEpcotEnabled"
                            [visiblePodLegs]="visiblePodLegs" />
                    } @else {
                        <ms-popular-bets-pod
                            msPopularBetsPodBackground
                            [pod]="pod"
                            [isEpcotEnabled]="isEpcotEnabled"
                            [visiblePodLegs]="visiblePodLegs" />
                    }
                </li>
            </ul>
        </ms-scroll-adapter>
    </div>
}
